import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowRight,
  Phone,
  Instagram,
  MessageCircle,
  FileText,
  Loader2,
  Lock,
  Trophy,
  X,
  MapPin,
  Mail,
  ShieldCheck,
  Sparkles,
} from "lucide-react";
import { WinnerModal } from "../components/site/WinnerSection";
import LegalDocsFooter from "../components/site/LegalDocsFooter";
import { IMG } from "@/data/content";

/* ============================================================
   ÁREA EDITÁVEL — atualize os preços, links e imagens aqui.
   ============================================================ */

/* Flag global: quando false, bloqueia todas as compras dos planos */
const SALES_OPEN = true;

const PRECO_COMBO_1 = "R$ 147";
const PRECO_COMBO_2 = "R$ 197";
const PRECO_COMBO_3 = "R$ 297";

const PARCELA_COMBO_1 = "12x de R$ 14,09";
const PARCELA_COMBO_2 = "12x de R$ 18,88";
const PARCELA_COMBO_3 = "12x de R$ 28,46";

const LINK_INFINITEPAY_COMBO_1 = "PLANO1";
const LINK_INFINITEPAY_COMBO_2 = "PLANO2";
const LINK_INFINITEPAY_COMBO_3 = "PLANO3";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LINK_REGULAMENTO = "#regulamento";
const LINK_WHATSAPP =
  "https://wa.me/5547999686547?text=Ol%C3%A1%2C%20quero%20saber%20sobre%20o%20Clube%20Dive%20Master";
const LINK_INSTAGRAM = "https://www.instagram.com/mergulhobc";
const LINK_TERMOS = "#termos";
const LINK_PRIVACIDADE = "#privacidade";

const IMG_HERO = "/images/couple-diving-new.jpg"; // troque por uma imagem específica do clube
const IMG_BANNER = "/images/clube-banner.webp";
const IMG_LOGO = IMG.logo;

/* ============================================================ */

const EASE = [0.16, 1, 0.3, 1];

const CLUB_BENEFITS = [
  "20% OFF no Batismo",
  "R$ 800 OFF em qualquer curso",
  "R$ 1.000 OFF em Abrolhos",
  "R$ 1.000 OFF em Paraty",
  "R$ 1.000 OFF em Recife",
  "R$ 500 OFF em futuras expedições nacionais",
  "R$ 1.000 OFF em expedições internacionais",
  "20% OFF em equipamentos Cressi",
  "Acesso antecipado ao DiverTrack Premium",
  "Novos benefícios durante o ano",
];


const PRIZES_CARDS = [
  {
    slug: "abrolhos",
    emoji: "🐋",
    title: "Expedição para Abrolhos",
    text: "Expedição completa para você e um acompanhante — todas as despesas pagas. Todos os membros do clube participam do sorteio.",
    img: "https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=1000&auto=format&fit=crop&q=75",
    status: "revealed",
    statusLabel: "Sorteio realizado 26/07",
  },
  {
    slug: "abrolhos-novo",
    emoji: "🐋",
    title: "Novo sorteio Abrolhos",
    text: "NOVIDADE: mais uma expedição completa para 2 pessoas, com todas as despesas pagas. Concorrem apenas os 100 primeiros a entrar — seja rápido, as vagas são por ordem de entrada.",
    img: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1000&auto=format&fit=crop&q=75",
    status: "active",
    statusLabel: "Novidade · 100 primeiros a entrar",
  },
  {
    slug: "curso",
    emoji: "🎓",
    title: "Curso de mergulho para 2",
    text: "Curso completo para 2 membros do clube. Os 100 primeiros a entrar concorrem.",
    img: "https://images.unsplash.com/photo-1682687982501-1e58ab814714?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Em breve",
  },
  {
    slug: "paraty",
    emoji: "🏝️",
    title: "Expedição para Paraty",
    text: "Ao atingirmos 300 membros: viagem para Paraty para 2 pessoas com todas as despesas pagas.",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera ao atingir 300 membros",
  },
  {
    slug: "dubai",
    emoji: "🎁",
    title: "Conhecer Dubai (Prêmio Surpresa)",
    text: "Conheça Dubai e mergulhe na piscina mais funda do mundo — para você e um acompanhante, todas as despesas pagas. Exclusivo para as 500 primeiras pessoas.",
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera com as 500 primeiras",
  },
  {
    slug: "tailandia",
    emoji: "🏆",
    title: "Tailândia (Grande Prêmio)",
    text: "Ao atingirmos 2.000 membros: viagem para a Tailândia para você e um acompanhante, todas as despesas pagas.",
    img: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Libera ao atingir 2.000 membros",
  },
  {
    slug: "hospedagem",
    emoji: "🏖️",
    title: "Hospedagem de frente pro mar",
    text: "Hospedagem com mergulho para credenciado ou batismo incluso.",
    img: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Em breve",
  },
  {
    slug: "mais-premios",
    emoji: "🎉",
    title: "E muito mais prêmios ao longo do ano",
    text: "Novos prêmios serão liberados no decorrer de 1 ano dentro do clube — e você participa automaticamente de todos.",
    img: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1000&auto=format&fit=crop&q=75",
    status: "locked",
    statusLabel: "Novos prêmios ao longo do ano",
  },
];

const COMBOS = [
  {
    id: 1,
    title: "Plano 1",
    numbers: 10,
    price: PRECO_COMBO_1,
    parcelas: PARCELA_COMBO_1,
    text:
      "Entre para o Clube Dive Master e garanta 10 números da sorte para concorrer a Abrolhos, Tailândia e outros prêmios.",
    button: "Quero o plano 1",
    small: "Entrar no Clube + 10 números da sorte",
    produto: LINK_INFINITEPAY_COMBO_1,
    tag: "Pra começar",
    theme: "cyan",
  },
  {
    id: 2,
    title: "Plano 2",
    numbers: 20,
    price: PRECO_COMBO_2,
    parcelas: PARCELA_COMBO_2,
    text:
      "Entre para o Clube Dive Master e aumente suas chances com 20 números da sorte para concorrer a Abrolhos, Tailândia e outros prêmios.",
    button: "Quero o plano 2",
    small: "Entrar no Clube + 20 números da sorte + R$100 de desconto",
    produto: LINK_INFINITEPAY_COMBO_2,
    tag: "Mais escolhido",
    theme: "blue",
    bonus: "Ganhe R$100 de desconto nos serviços de mergulho da escola",
  },
  {
    id: 3,
    title: "Plano 3",
    numbers: 40,
    price: PRECO_COMBO_3,
    parcelas: PARCELA_COMBO_3,
    text:
      "Entre para o Clube Dive Master e garanta 40 números da sorte para aumentar ainda mais suas chances de concorrer a Abrolhos, Tailândia e outros prêmios.",
    button: "Quero o plano 3",
    small: "Entrar no Clube + 40 números da sorte + 1 mergulho (batismo ou credenciado)",
    produto: LINK_INFINITEPAY_COMBO_3,
    tag: "Melhor oferta",
    theme: "gold",
    bonus: "Ganhe 1 mergulho de batismo ou credenciado incluso",
  },
];

const INFOS = [
  "Todos os planos dão acesso ao Clube Dive Master.",
  "A diferença entre as opções é a quantidade de números da sorte.",
  "Os membros terão acesso aos benefícios exclusivos do Clube durante o período informado.",
  "Os números da sorte serão utilizados nas ações e sorteios do Clube, conforme o regulamento.",
  "O pagamento será realizado com segurança pela InfinitePay.",
  "Após a confirmação do pagamento, a equipe Dive Master enviará as orientações de acesso.",
];

export default function ClubeDiveMaster() {
  const combosRef = useRef(null);
  const [loadingCombo, setLoadingCombo] = useState(null);
  const [selected, setSelected] = useState(null); // combo pending purchase
  const [form, setForm] = useState({ full_name: "", email: "", phone: "" });
  const [formError, setFormError] = useState(null);
  const [membersCount, setMembersCount] = useState(1);
  const [winnerOpen, setWinnerOpen] = useState(false);

  useEffect(() => {
    document.title = "Clube Dive Master — Escolha seu plano";
    // Área preparada para instalação futura de Meta Pixel / GTM (herdará do index.html)
  }, []);

  // Live members counter — social proof: grows from 1 to 87 in ~60s, then stops.
  useEffect(() => {
    if (selected) return; // pause when user is checking out

    const intervalId = setInterval(() => {
      setMembersCount((c) => {
        if (c >= 87) {
          clearInterval(intervalId);
          return c;
        }
        return c + 1;
      });
    }, 730);

    return () => clearInterval(intervalId);
  }, [selected]);

  const scrollToCombos = () => {
    combosRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openPurchaseModal = (combo) => {
    if (!SALES_OPEN) return; // vendas bloqueadas
    if (loadingCombo) return;
    const evt = `click_combo_${combo.id}`;
    if (typeof window !== "undefined") {
      if (typeof window.fbq === "function") window.fbq("trackCustom", evt, { combo: combo.id });
      if (typeof window.dataLayer !== "undefined") window.dataLayer.push({ event: evt, combo_id: combo.id });
    }
    setSelected(combo);
    setFormError(null);
  };

  const closeModal = () => {
    if (loadingCombo) return;
    setSelected(null);
    setFormError(null);
  };

  const goToPayment = async (e) => {
    e?.preventDefault?.();
    if (!selected || loadingCombo) return;
    // basic validation
    const nome = form.full_name.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    if (nome.length < 2 || !email.includes("@") || phone.replace(/\D/g, "").length < 8) {
      setFormError("Por favor, preencha nome, e-mail e telefone corretamente.");
      return;
    }
    setFormError(null);
    setLoadingCombo(selected.id);
    try {
      const { data } = await axios.post(`${API}/checkout/criar`, {
        produto: selected.produto,
        full_name: nome,
        email,
        phone,
      });
      if (data?.url) {
        window.location.href = data.url;
        return;
      }
      throw new Error("URL vazia");
    } catch (err) {
      setLoadingCombo(null);
      const msg =
        err?.response?.data?.detail ||
        "Não foi possível iniciar o pagamento. Tente novamente em instantes.";
      setFormError(msg);
    }
  };

  return (
    <main
      className="relative min-h-[100svh] overflow-x-hidden bg-[#04102A] text-white"
      data-testid="clube-page"
    >
      {/* ================== BANNER TOPO ================== */}
      <section className="relative w-full bg-[#04102A]" data-testid="clube-banner">
        <img
          src={IMG_BANNER}
          alt="Chegou o Clube Dive Master — Mergulhe mais, pague menos. Viva o extraordinário!"
          className="block h-auto w-full"
        />
      </section>

      {/* ================== DIVISÓRIA IRADA ================== */}
      <div className="relative -mt-1 h-16 w-full overflow-hidden sm:h-24" aria-hidden="true">
        {/* Wave shape */}
        <svg
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
          className="absolute inset-x-0 top-0 block h-full w-full"
        >
          <defs>
            <linearGradient id="waveGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#7BE0D6" stopOpacity="1" />
              <stop offset="50%" stopColor="#F5C542" stopOpacity="1" />
              <stop offset="100%" stopColor="#7BE0D6" stopOpacity="1" />
            </linearGradient>
          </defs>
          {/* Top gradient line */}
          <path
            d="M0,20 C240,60 480,0 720,30 C960,60 1200,0 1440,25 L1440,32 L0,32 Z"
            fill="url(#waveGrad)"
            opacity="0.9"
          />
          {/* Filled wave in navy */}
          <path
            d="M0,40 C240,90 480,10 720,50 C960,90 1200,20 1440,50 L1440,120 L0,120 Z"
            fill="#04102A"
          />
        </svg>
        {/* Sparkle dots */}
        <div className="absolute inset-x-0 top-8 flex justify-center gap-6 opacity-90 sm:top-10">
          <span className="h-1.5 w-1.5 rounded-full bg-[#F5C542] shadow-[0_0_10px_rgba(245,197,66,0.9)]" />
          <span className="h-1 w-1 rounded-full bg-[#7BE0D6]" />
          <span className="h-2 w-2 rounded-full bg-[#F5C542] shadow-[0_0_12px_rgba(245,197,66,0.9)]" />
          <span className="h-1 w-1 rounded-full bg-[#7BE0D6]" />
          <span className="h-1.5 w-1.5 rounded-full bg-[#F5C542] shadow-[0_0_10px_rgba(245,197,66,0.9)]" />
        </div>
      </div>

      {/* ================== COMBOS ================== */}
      <section
        ref={combosRef}
        id="combos"
        className="relative bg-gradient-to-b from-[#04102A] via-[#0A1F52] to-[#04102A] px-5 pb-24 pt-14 sm:pb-32 sm:pt-20"
        data-testid="combos-section"
      >
        <div className="mx-auto max-w-6xl">
          <div className="text-center">
            <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
              Passo único
            </p>
            <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-4xl">
              Escolha seu plano
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm text-white/70 sm:text-base">
              Todos os planos dão acesso ao Clube Dive Master{" "}
              <strong className="font-bold text-white">por 1 ano</strong>. A diferença está na
              quantidade de números da sorte e no bônus.
            </p>
            <p className="mx-auto mt-5 max-w-2xl font-display text-base font-black uppercase leading-snug tracking-tight text-[#F5C542] sm:text-lg">
              Quanto mais números da sorte, mais chances de ganhar as premiações do Clube.
            </p>

            {/* Live members counter — social proof */}
            <div className="mt-6 flex justify-center" data-testid="live-members-counter">
              <div className="inline-flex items-center gap-2.5 rounded-full border border-[#F5C542]/40 bg-[#04102A]/80 px-4 py-2 shadow-lg shadow-black/40 backdrop-blur-md">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F5C542] opacity-75" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F5C542]" />
                </span>
                <p className="text-xs font-bold text-white sm:text-sm">
                  <span className="font-black text-[#F5C542]">{membersCount}</span>{" "}
                  {membersCount === 1 ? "pessoa já entrou" : "pessoas já entraram"} no clube
                </p>
              </div>
            </div>
          </div>

          {/* ============ VENDAS TEMPORARIAMENTE PAUSADAS ============ */}
          {!SALES_OPEN && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: EASE }}
              className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border-2 border-[#F5C542]/50 bg-gradient-to-br from-[#F5C542]/15 via-[#04102A]/40 to-transparent p-6 text-center shadow-2xl shadow-[#F5C542]/20 sm:p-8"
              data-testid="sales-closed-banner"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#F5C542] text-[#04102A] shadow-lg shadow-[#F5C542]/40 sm:h-16 sm:w-16">
                <Lock className="h-7 w-7 sm:h-8 sm:w-8" strokeWidth={2.4} />
              </div>
              <p className="mt-4 text-[10px] font-black uppercase tracking-[0.3em] text-[#F5C542]">
                Vendas temporariamente pausadas
              </p>
              <h3 className="mt-2 font-display text-2xl font-black uppercase leading-tight tracking-tight text-white sm:text-3xl">
                As inscrições reabrem em breve
              </h3>
              <p className="mx-auto mt-3 max-w-lg text-sm text-white/80 sm:text-base">
                Fique atento: os planos serão liberados novamente muito em breve.
                Enquanto isso, entre no nosso grupo VIP para ser avisado em primeira mão.
              </p>
              <a
                href="https://chat.whatsapp.com/DQWqi1uziSk90WektD0Q7n?s=cl&p=a&mlu=0&amv=1"
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-extrabold uppercase tracking-wide text-white shadow-lg shadow-[#25D366]/40 transition-transform hover:scale-105"
                data-testid="sales-closed-vip-cta"
              >
                <MessageCircle className="h-5 w-5" />
                Entrar no grupo VIP
              </a>
            </motion.div>
          )}

          <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
            {COMBOS.map((c) => (
              <ComboCard
                key={c.id}
                combo={c}
                loading={loadingCombo === c.id}
                salesOpen={SALES_OPEN}
                onSelect={() => openPurchaseModal(c)}
              />
            ))}
          </div>

          {/* ============ 14 DIAS DE GARANTIA — BLOCO GRANDE ============ */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="relative mx-auto mt-16 max-w-4xl overflow-hidden rounded-3xl border-2 border-[#7BE0D6]/50 bg-gradient-to-br from-[#0F2C6F] via-[#0A1F52] to-[#04102A] p-6 shadow-2xl shadow-[#7BE0D6]/20 sm:p-10"
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#7BE0D6]/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-20 -left-20 h-56 w-56 rounded-full bg-[#F5C542]/15 blur-3xl" />

            <div className="relative flex flex-col items-center gap-6 text-center sm:flex-row sm:text-left">
              <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-3xl bg-[#7BE0D6] text-[#04102A] shadow-2xl shadow-[#7BE0D6]/50 sm:h-32 sm:w-32">
                <ShieldCheck className="h-14 w-14 sm:h-20 sm:w-20" strokeWidth={2.2} />
              </div>

              <div className="flex-1">
                <p className="text-[11px] font-black uppercase tracking-[0.32em] text-[#7BE0D6] sm:text-xs">
                  Compra sem risco
                </p>
                <h3 className="mt-2 font-display text-4xl font-black uppercase leading-none tracking-tight text-white sm:text-6xl">
                  14 dias de garantia
                </h3>
                <p className="mt-4 text-base leading-relaxed text-white/85 sm:text-lg">
                  Se mudar de ideia por qualquer motivo,{" "}
                  <strong className="font-bold text-[#F5C542]">devolvemos 100% do valor</strong>{" "}
                  — sem burocracia, sem perguntas.
                </p>
                <button
                  type="button"
                  onClick={() =>
                    window.dispatchEvent(
                      new CustomEvent("open-legal-doc", { detail: "cancelamento" })
                    )
                  }
                  className="mt-3 inline-block text-xs font-semibold text-white/55 underline-offset-4 transition-colors hover:text-white/85 hover:underline sm:text-sm"
                  data-testid="link-politica-reembolso"
                >
                  Veja a política de reembolso
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================== PRÊMIOS DO SORTEIO + PROVA SOCIAL ================== */}
      <section
        className="relative overflow-hidden bg-[#071B2D] px-5 py-20 sm:py-24"
        data-testid="prizes-section"
      >
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -left-24 top-24 h-72 w-72 rounded-full bg-[#F5C542]/10 blur-3xl" />
          <div className="absolute -right-24 bottom-24 h-80 w-80 rounded-full bg-[#3B82F6]/10 blur-3xl" />
        </div>

        <div className="relative mx-auto max-w-6xl">
          {/* Strip: 1 prêmio já sorteado */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-3xl border-2 border-[#F5C542]/50 bg-gradient-to-br from-[#F5C542]/[0.1] to-transparent p-6 text-center backdrop-blur-md sm:flex-row sm:gap-6 sm:p-8 sm:text-left"
          >
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#F5C542] text-[#04102A] shadow-lg shadow-[#F5C542]/40 sm:h-20 sm:w-20">
              <Trophy className="h-9 w-9 sm:h-11 sm:w-11" strokeWidth={2.2} />
            </div>
            <div className="flex-1">
              <p className="text-[10px] font-black uppercase tracking-[0.28em] text-[#F5C542]">
                Prova social
              </p>
              <h3 className="mt-1 font-display text-xl font-black uppercase leading-tight tracking-tight text-white sm:text-2xl">
                Já temos 1 prêmio sorteado — e um ganhador oficial!
              </h3>
              <p className="mt-2 text-xs text-white/70 sm:text-sm">
                A expedição de Abrolhos já saiu. Ainda tem muitos prêmios pela frente e
                você entra concorrendo a todos.
              </p>
            </div>
            <button
              type="button"
              onClick={() => {
                setWinnerOpen(true);
                if (typeof window !== "undefined" && typeof window.fbq === "function") {
                  window.fbq("trackCustom", "click_confira_ganhador");
                }
              }}
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#F5C542] px-5 py-3 text-xs font-extrabold uppercase tracking-wide text-[#04102A] shadow-lg shadow-[#F5C542]/40 transition-transform hover:scale-[1.03] sm:text-sm"
              data-testid="btn-confira-ganhador-clube"
            >
              <Trophy className="h-4 w-4" strokeWidth={2.6} />
              Confira quem ganhou
              <ArrowRight className="h-4 w-4" />
            </button>
          </motion.div>

          {/* Cards de prêmios */}
          <div className="mt-16 text-center">
            <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
              Ao entrar no Clube
            </p>
            <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-4xl">
              Você concorre a estes prêmios
            </h2>
          </div>

          <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {PRIZES_CARDS.map((c) => {
              const isLocked = c.status === "locked";
              const isRevealed = c.status === "revealed";
              const isActive = c.status === "active";
              return (
                <div
                  key={c.title}
                  className={`group relative overflow-hidden rounded-3xl border backdrop-blur-md transition-colors ${
                    isRevealed
                      ? "border-[#F5C542]/70 bg-[#F5C542]/[0.06] shadow-2xl shadow-[#F5C542]/20"
                      : isActive
                      ? "border-[#7BE0D6]/70 bg-[#7BE0D6]/[0.06] shadow-2xl shadow-[#7BE0D6]/20"
                      : "border-white/10 bg-white/5 hover:border-white/20"
                  }`}
                  data-testid={`prize-card-${c.slug}`}
                >
                  <div className="relative aspect-[16/10] w-full overflow-hidden">
                    <img
                      src={c.img}
                      alt={c.title}
                      loading="lazy"
                      className={`h-full w-full object-cover transition-all duration-700 group-hover:scale-105 ${
                        isLocked ? "grayscale-[0.6] brightness-[0.55]" : ""
                      }`}
                    />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#071B2D] via-[#071B2D]/20 to-transparent" />
                    <span className="absolute left-4 top-4 text-3xl drop-shadow-lg">{c.emoji}</span>

                    {isLocked && (
                      <div className="absolute right-3 top-3 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-[#071B2D]/85 backdrop-blur-md">
                        <Lock className="h-5 w-5 text-white/85" strokeWidth={2.4} />
                      </div>
                    )}

                    {isRevealed && (
                      <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-[#F5C542] bg-[#F5C542] px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-[#04102A] shadow-lg">
                        <Trophy className="h-3.5 w-3.5" strokeWidth={2.6} />
                        Já saiu!
                      </div>
                    )}

                    {isActive && (
                      <div className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-[#7BE0D6] bg-[#7BE0D6] px-3 py-1.5 text-[10px] font-black uppercase tracking-widest text-[#04102A] shadow-lg">
                        <span className="relative flex h-2 w-2">
                          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#04102A] opacity-60" />
                          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#04102A]" />
                        </span>
                        Novidade
                      </div>
                    )}
                  </div>

                  <div className="p-6">
                    <h3 className="font-display text-xl font-black uppercase leading-tight tracking-tight text-white">
                      {c.title}
                    </h3>
                    <p
                      className={`mt-2 inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest ${
                        isRevealed
                          ? "text-[#F5C542]"
                          : isActive
                          ? "text-[#7BE0D6]"
                          : "text-white/50"
                      }`}
                    >
                      {isRevealed ? (
                        <Trophy className="h-3.5 w-3.5" strokeWidth={2.6} />
                      ) : isActive ? (
                        <Sparkles className="h-3.5 w-3.5" strokeWidth={2.6} />
                      ) : (
                        <Lock className="h-3.5 w-3.5" strokeWidth={2.6} />
                      )}
                      {c.statusLabel}
                    </p>
                    <p className="mt-2 text-sm text-white/70">{c.text}</p>

                    {isRevealed && (
                      <button
                        type="button"
                        onClick={() => setWinnerOpen(true)}
                        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#F5C542] px-5 py-3 text-sm font-extrabold uppercase tracking-wide text-[#04102A] shadow-lg shadow-[#F5C542]/30 transition-transform hover:scale-[1.03]"
                      >
                        <Trophy className="h-4 w-4" strokeWidth={2.6} />
                        Confira quem ganhou
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ================== BENEFÍCIOS DO CLUBE ================== */}
      <section
        className="relative bg-gradient-to-b from-[#02081F] via-[#0A1F52] to-[#02081F] px-5 py-24 sm:py-28"
        data-testid="benefits-section"
      >
        <div className="mx-auto max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="text-center"
          >
            <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#7BE0D6]">
              Membros
            </p>
            <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight sm:text-4xl">
              Benefícios do Clube Dive Master
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/75 sm:text-base">
              Todos os membros têm acesso a estes benefícios{" "}
              <strong className="font-bold text-white">durante 1 ano</strong>. Os valores
              abaixo são{" "}
              <strong className="font-bold text-white">descontos aplicáveis sobre qualquer produto</strong>{" "}
              vendido no nosso site oficial durante esse período.
            </p>
          </motion.div>

          <ul className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {CLUB_BENEFITS.map((b, i) => (
              <motion.li
                key={b}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.04, ease: EASE }}
                className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-sm"
              >
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#7BE0D6]/15 text-[#7BE0D6]">
                  <ShieldCheck className="h-4 w-4" strokeWidth={2.5} />
                </span>
                <p className="text-sm text-white/90 sm:text-base">{b}</p>
              </motion.li>
            ))}
          </ul>
        </div>
      </section>

      {/* ================== PRÓXIMO SORTEIO ================== */}
      <section
        className="relative overflow-hidden bg-[#071B2D] px-5 py-20 sm:py-24"
        data-testid="next-prize-section"
      >
        <div className="pointer-events-none absolute -right-24 top-16 h-72 w-72 rounded-full bg-[#F5C542]/10 blur-3xl" />
        <div className="pointer-events-none absolute -left-24 bottom-16 h-72 w-72 rounded-full bg-[#3B82F6]/10 blur-3xl" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border-2 border-[#F5C542] bg-gradient-to-br from-[#3D2F0A] via-[#1A2A5A] to-[#0A1F52] p-6 shadow-2xl shadow-[#F5C542]/25 sm:p-10"
        >
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#F5C542]/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-[#3B82F6]/20 blur-3xl" />

          <div className="relative flex flex-col items-center gap-6 text-center sm:flex-row sm:text-left">
            <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-3xl bg-[#F5C542] text-[#04102A] shadow-lg shadow-[#F5C542]/40 sm:h-24 sm:w-24">
              <Trophy className="h-11 w-11 sm:h-14 sm:w-14" strokeWidth={2.2} />
            </div>
            <div className="flex-1">
              <p className="text-[11px] font-black uppercase tracking-[0.28em] text-[#F5C542]">
                🎁 Próximo sorteio
              </p>
              <h3 className="mt-2 font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-4xl">
                2 cursos de mergulho
              </h3>
              <p className="mt-2 text-sm text-white/80 sm:text-base">
                Serão <strong className="font-bold text-[#F5C542]">2 vencedores diferentes</strong>.
                Cada vencedor poderá escolher entre:
              </p>
              <ul className="mt-4 space-y-2 text-sm sm:text-base">
                <li className="flex items-start gap-2 text-white/90">
                  <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F5C542]" />
                  Open Water Diver
                </li>
                <li className="flex items-start gap-2 text-white/90">
                  <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F5C542]" />
                  Advanced Open Water Diver (caso já seja certificado)
                </li>
              </ul>
              <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/30 px-4 py-2 text-[11px] font-bold text-white/70">
                <Lock className="h-3.5 w-3.5" /> Data do próximo sorteio será divulgada em breve
              </div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ================== FOOTER ================== */}
      <footer className="relative border-t border-white/10 bg-[#020A1E] px-5 py-12 text-center">
        <div className="mx-auto max-w-3xl">
          <img src={IMG_LOGO} alt="Dive Master" className="mx-auto h-14 w-auto opacity-90" />
          <p className="mt-3 text-xs font-black uppercase tracking-[0.24em] text-white/80">
            Dive Master Escola de Mergulho
          </p>

          {/* Endereço + CNPJ */}
          <div className="mx-auto mt-6 max-w-md space-y-2 text-sm text-white/75">
            <p className="flex items-center justify-center gap-2">
              <MapPin className="h-4 w-4 shrink-0 text-[#7BE0D6]" />
              Rua José Alexandre Rocha, 63 — Bairro Perequê, Porto Belo/SC
            </p>
            <p className="flex items-center justify-center gap-2">
              <FileText className="h-4 w-4 shrink-0 text-[#7BE0D6]" />
              CNPJ 50.990.553/0001-07
            </p>
            <p className="flex items-center justify-center gap-2">
              <Phone className="h-4 w-4 shrink-0 text-[#7BE0D6]" />
              (47) 99968-6547
            </p>
          </div>

          {/* Redes sociais */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm">
            <a
              href={LINK_INSTAGRAM}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-white/70 hover:text-white"
            >
              <Instagram className="h-4 w-4" /> @mergulhobc
            </a>
            <span className="text-white/20">·</span>
            <a
              href={LINK_WHATSAPP}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-white/70 hover:text-white"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>

          <p className="mx-auto mt-6 text-[11px] leading-relaxed text-white/40">
            © {new Date().getFullYear()} Dive Master Escola de Mergulho. Todos os direitos reservados.
          </p>

          <LegalDocsFooter />
        </div>
      </footer>

      {/* ================== WHATSAPP FLOAT ================== */}
      <motion.a
        href="https://wa.me/5547999686547?text=Ol%C3%A1%2C%20tenho%20d%C3%BAvidas%20com%20rela%C3%A7%C3%A3o%20ao%20clube%20e%20ao%20sorteio."
        target="_blank"
        rel="noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.9, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="fixed bottom-4 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/40 sm:bottom-6 sm:right-6 sm:h-16 sm:w-16"
        aria-label="Tirar dúvidas no WhatsApp"
        data-testid="clube-whatsapp-float"
      >
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white sm:h-8 sm:w-8" aria-hidden="true">
          <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.712 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.233 1.588h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.71 12.71 0 0 0 16.003 3.2Zm0 23.04h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.05 1.07-3.9-.253-.4a10.56 10.56 0 0 1-1.62-5.63c0-5.87 4.777-10.646 10.65-10.646 2.845 0 5.518 1.108 7.53 3.12a10.58 10.58 0 0 1 3.117 7.53c0 5.872-4.777 10.65-10.65 10.65Zm5.84-7.976c-.32-.16-1.894-.935-2.188-1.042-.293-.107-.507-.16-.72.16-.214.32-.826 1.042-1.013 1.256-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.95-.848-1.593-1.895-1.78-2.215-.186-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.214.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.095-1.12 2.67 0 1.575 1.147 3.097 1.307 3.31.16.214 2.253 3.44 5.46 4.826.763.33 1.36.527 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347Z" />
        </svg>
      </motion.a>

      {/* ================== PURCHASE MODAL ================== */}
      <AnimatePresence>
        {selected && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[80] flex items-end justify-center bg-black/70 backdrop-blur-sm sm:items-center"
            onClick={closeModal}
            data-testid="purchase-modal"
          >
            <motion.div
              initial={{ y: 60, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 60, opacity: 0 }}
              transition={{ duration: 0.35, ease: EASE }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-full max-w-md overflow-hidden rounded-t-3xl bg-[#04102A] p-6 shadow-2xl ring-1 ring-white/10 sm:rounded-3xl sm:p-8"
            >
              <button
                type="button"
                onClick={closeModal}
                aria-label="Fechar"
                className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white/80 hover:bg-white/20"
              >
                <X className="h-4 w-4" />
              </button>

              <p className="text-[10px] font-black uppercase tracking-[0.24em] text-[#7BE0D6]">
                {selected.title}
              </p>
              <h3 className="mt-2 font-display text-2xl font-black uppercase leading-tight text-white sm:text-3xl">
                Preencha seus dados
              </h3>
              <p className="mt-2 text-sm text-white/70">
                Vamos registrar seu pedido antes de te direcionar para o pagamento seguro.
              </p>

              <form onSubmit={goToPayment} className="mt-6 space-y-3">
                <input
                  type="text"
                  required
                  autoFocus
                  placeholder="Nome completo"
                  value={form.full_name}
                  onChange={(e) => setForm((s) => ({ ...s, full_name: e.target.value }))}
                  className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-base text-white placeholder-white/40 outline-none focus:border-[#F5C542]"
                  data-testid="modal-nome"
                />
                <input
                  type="email"
                  required
                  placeholder="Seu melhor e-mail"
                  value={form.email}
                  onChange={(e) => setForm((s) => ({ ...s, email: e.target.value }))}
                  className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-base text-white placeholder-white/40 outline-none focus:border-[#F5C542]"
                  data-testid="modal-email"
                />
                <input
                  type="tel"
                  required
                  placeholder="WhatsApp (com DDD)"
                  value={form.phone}
                  onChange={(e) => setForm((s) => ({ ...s, phone: e.target.value }))}
                  className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-base text-white placeholder-white/40 outline-none focus:border-[#F5C542]"
                  data-testid="modal-phone"
                />

                {formError && (
                  <p className="rounded-xl border border-red-400/40 bg-red-500/10 px-3 py-2 text-sm text-red-200">
                    {formError}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={loadingCombo === selected.id}
                  className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#F5C542] px-6 py-4 text-base font-extrabold uppercase tracking-wide text-[#04102A] shadow-lg shadow-[#F5C542]/30 disabled:opacity-70"
                  data-testid="modal-submit"
                >
                  {loadingCombo === selected.id ? (
                    <>
                      <Loader2 className="h-5 w-5 animate-spin" /> Direcionando para o pagamento…
                    </>
                  ) : (
                    <>
                      Ir para o pagamento
                      <ArrowRight className="h-5 w-5" />
                    </>
                  )}
                </button>

                <p className="mt-2 text-center text-[11px] text-white/50">
                  <Lock className="mr-1 inline h-3 w-3" /> Pagamento seguro pela InfinitePay
                </p>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ================== MODAL: VENCEDOR ABROLHOS ================== */}
      <WinnerModal open={winnerOpen} onClose={() => setWinnerOpen(false)} />
    </main>
  );
}

/* ============================================================
   COMPONENTS
   ============================================================ */

const THEMES = {
  cyan: {
    border: "border-[#7BE0D6]/60",
    cardBg: "bg-gradient-to-b from-white/[0.07] to-white/[0.02] backdrop-blur-sm",
    shadow: "shadow-xl shadow-[#7BE0D6]/10",
    tagBg: "bg-[#7BE0D6] text-[#04102A]",
    number: "text-[#7BE0D6]",
    bonusBorder: "border-[#7BE0D6]/40",
    bonusBg: "bg-[#7BE0D6]/10",
    bonusIconBg: "bg-[#7BE0D6] text-[#04102A]",
    bonusLabel: "text-[#7BE0D6]",
    ctaBg: "bg-[#7BE0D6] text-[#04102A]",
    ctaShadow: "shadow-lg shadow-[#7BE0D6]/40",
    accentText: "text-[#7BE0D6]",
  },
  blue: {
    border: "border-[#3B82F6]",
    cardBg: "bg-gradient-to-b from-[#0F2C6F]/70 to-[#0A1F52]/90",
    shadow: "shadow-2xl shadow-[#3B82F6]/25",
    tagBg: "bg-[#3B82F6] text-white",
    number: "text-[#8FB4FF]",
    bonusBorder: "border-[#3B82F6]/50",
    bonusBg: "bg-[#3B82F6]/15",
    bonusIconBg: "bg-[#3B82F6] text-white",
    bonusLabel: "text-[#8FB4FF]",
    ctaBg: "bg-[#3B82F6] text-white",
    ctaShadow: "shadow-lg shadow-[#3B82F6]/50",
    accentText: "text-[#8FB4FF]",
  },
  gold: {
    border: "border-[#F5C542]",
    cardBg: "bg-gradient-to-b from-[#3D2F0A] via-[#1A2A5A] to-[#0A1F52]",
    shadow: "shadow-2xl shadow-[#F5C542]/30",
    tagBg: "bg-[#F5C542] text-[#04102A]",
    number: "text-[#F5C542]",
    bonusBorder: "border-[#F5C542]/60",
    bonusBg: "bg-[#F5C542]/15",
    bonusIconBg: "bg-[#F5C542] text-[#04102A]",
    bonusLabel: "text-[#F5C542]",
    ctaBg: "bg-[#F5C542] text-[#04102A]",
    ctaShadow: "shadow-lg shadow-[#F5C542]/50",
    accentText: "text-[#F5C542]",
  },
};

function ComboCard({ combo, loading, onSelect, salesOpen = true }) {
  const t = THEMES[combo.theme] || THEMES.cyan;
  const isGold = combo.theme === "gold";
  const disabled = !salesOpen;
  return (
    <motion.button
      onClick={onSelect}
      whileHover={disabled ? {} : { y: -6 }}
      transition={{ duration: 0.35, ease: EASE }}
      disabled={disabled}
      className={`group relative flex w-full flex-col overflow-hidden rounded-3xl border-2 p-6 text-left transition-shadow sm:p-7 ${t.border} ${t.cardBg} ${t.shadow} ${
        isGold && !disabled ? "sm:scale-[1.02]" : ""
      } ${disabled ? "cursor-not-allowed opacity-70" : ""}`}
      data-testid={`combo-card-${combo.id}`}
    >
      {/* Ambient glow for premium plans */}
      {isGold && (
        <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#F5C542]/25 blur-3xl" />
      )}
      {combo.theme === "blue" && (
        <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#3B82F6]/25 blur-3xl" />
      )}

      {combo.tag && (
        <span
          className={`absolute right-4 top-4 rounded-full px-3 py-1 text-[10px] font-black uppercase tracking-widest shadow-md ${t.tagBg}`}
        >
          {combo.tag}
        </span>
      )}

      <p className="relative text-[11px] font-black uppercase tracking-[0.22em] text-white/60">
        {combo.title}
      </p>

      <div className="relative mt-3 flex items-baseline gap-2">
        <span
          className={`font-display text-5xl font-black leading-none sm:text-6xl ${t.number}`}
        >
          {combo.numbers}
        </span>
        <span className="text-sm font-bold uppercase tracking-wider text-white/70">
          números
        </span>
      </div>
      <p className={`relative mt-1 text-xs font-bold uppercase tracking-widest ${t.accentText}`}>
        da sorte
      </p>

      <p className="relative mt-5 text-sm leading-relaxed text-white/80">{combo.text}</p>

      {combo.bonus && (
        <div
          className={`relative mt-4 flex items-start gap-3 rounded-2xl border p-3.5 ${t.bonusBorder} ${t.bonusBg}`}
          data-testid={`combo-bonus-${combo.id}`}
        >
          <span
            className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg shadow-md ${t.bonusIconBg}`}
          >
            {isGold ? "🤿" : "💸"}
          </span>
          <div>
            <p className={`text-[10px] font-black uppercase tracking-widest ${t.bonusLabel}`}>
              Bônus exclusivo
            </p>
            <p className="mt-0.5 text-sm font-bold leading-snug text-white">
              {combo.bonus}
            </p>
          </div>
        </div>
      )}

      <div className="relative mt-6 flex items-end justify-between gap-3">
        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-white/50">
            Investimento único
          </p>
          <p className={`mt-1 font-display text-2xl font-black leading-none sm:text-3xl ${t.accentText}`}>
            {combo.parcelas}
          </p>
          <p className="mt-1 text-xs text-white/70">
            ou <span className="font-bold text-white">{combo.price}</span> à vista
          </p>
          <p className={`mt-2 text-[10px] font-bold uppercase tracking-widest ${t.accentText}`}>
            Válido por 1 ano
          </p>
        </div>
      </div>

      <div
        className={`relative mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-sm font-extrabold uppercase tracking-wide transition-transform sm:text-base ${
          disabled
            ? "border border-white/20 bg-white/5 text-white/60"
            : `group-hover:scale-[1.02] ${t.ctaBg} ${t.ctaShadow}`
        }`}
      >
        {disabled ? (
          <>
            <Lock className="h-4 w-4" />
            Vendas em breve
          </>
        ) : loading ? (
          "Direcionando para o pagamento seguro…"
        ) : (
          combo.button
        )}
      </div>

      <p className="relative mt-3 text-center text-[11px] font-semibold text-white/50">
        {combo.small}
      </p>

      <div className={`relative mt-3 flex items-center justify-center gap-2 rounded-xl border px-3 py-2 text-center ${t.bonusBorder} ${t.bonusBg}`}>
        <Mail className={`h-4 w-4 shrink-0 ${t.accentText}`} />
        <p className="text-[11px] font-bold leading-snug text-white/90 sm:text-xs">
          Você recebe seus números da sorte direto no seu e-mail.
        </p>
      </div>
    </motion.button>
  );
}

function FaqStep({ n, title, text }) {
  return (
    <div className="flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F5C542] font-display text-lg font-black text-[#04102A]">
        {n}
      </span>
      <div>
        <h3 className="font-display text-lg font-black uppercase leading-tight tracking-tight text-white sm:text-xl">
          {title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-white/80 sm:text-base">{text}</p>
      </div>
    </div>
  );
}

function TrustItem({ icon: Icon, label }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#7BE0D6]/15 text-[#7BE0D6]">
        <Icon className="h-4 w-4" />
      </span>
      <p className="text-xs font-semibold text-white/85 sm:text-sm">{label}</p>
    </div>
  );
}
